module.exports = __webpack_public_path__ + "static/media/SCANGREJO_MENU-normal.c939309f.png";